import { useState } from "preact/compat";
import { route } from "preact-router";

function Feedback(props) {
  const [isOpen, setIsOpen] = useState(false);

  function onSubmit() {
    route('/search');
  }

  return (
    <div class="mx-auto block mt-4 bg-transparent text-gray-700 pt-2 px-5 overflow-scroll h-full pb-32">
      <a class="text-base text-gray-800 py-1 rounded inline-flex items-center mb-4" href="/search">
        <ion-icon class="mr-2" size="lage" name="arrow-back-circle-outline"></ion-icon>
        <span>Back </span>
      </a>
      <form class="w-full max-w-lg" onSubmit={onSubmit}>
        <div class="flex flex-wrap -mx-3">
          <div class="w-full px-3 mb-6">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              for="grid-first-name"
            >
              Search query:
            </label>
            <input
              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              id="grid-last-name"
              type="text"
              placeholder="Enter relevant search terms here"
            />
          </div>
        </div>
        <div class="flex flex-wrap -mx-3 mb-2">
          <div class="w-full px-3 mb-6">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              for="grid-state"
            >
              What could be better?*
            </label>
            <div class="relative">
              <select
                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                id="grid-state"
              >
                <option>Results</option>
                <option>Filtering</option>
                <option>Images</option>
                <option>Seachbox</option>
                <option>Other</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </div>
          </div>
          <div class="w-full px-3 mb-6">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              for="grid-zip"
            >
              Message*
            </label>
            <textarea
              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            />
          </div>
        </div>
        <button type="submit" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Submit</button>
      </form>
    </div>
  );
}

export default Feedback;



// WEBPACK FOOTER //
// ./route/Feedback.js